export default __webpack_public_path__ + "static/media/nft-love.f440c2ce.jpg";